import { Extension, generateJSON } from "@tiptap/core"
import { Plugin, PluginKey } from "@tiptap/pm/state"
import markdownit from "markdown-it"
import { extensions } from "../extensions"
import { fixImages, isMarkdown } from "./util"
// @ts-ignore No types
import { full as emoji } from "markdown-it-emoji"

export const MarkdownHandler = Extension.create({
  name: "markdownHandler",

  addProseMirrorPlugins() {
    const { editor } = this

    return [
      new Plugin({
        key: new PluginKey("markdownHandler"),
        props: {
          handlePaste(view, event) {
            // If the editor is not editable, do not handle paste
            if (view.props.editable && !view.props.editable(view.state))
              return false

            // If no clipboard data, do not handle paste
            if (!event.clipboardData) return false

            // If the clipboard data is HTML, let default paste handler handle it
            if (event.clipboardData.getData("text/html")) return false

            // Get the clipboard data as plain text
            const text = event.clipboardData.getData("text/plain")

            // If plain text & markdown, render it as HTML, generate Tiptap JSON, and insert it
            if (text && isMarkdown(event.clipboardData.getData("text/plain"))) {
              const md = new markdownit().use(emoji)
              let markdownHtml = md.render(text)

              // Turn images into figures
              markdownHtml = fixImages(markdownHtml)

              editor.commands.insertContent(
                generateJSON(markdownHtml, extensions),
                {
                  parseOptions: {
                    preserveWhitespace: false,
                  },
                }
              )
              return true
            }
          },
        },
      }),
    ]
  },
})

export default MarkdownHandler
